// Wire contract for the clubhouse-web-api team game-report-stats endpoint
// (`/clubhouse/groups/{groupId}/game-report-stats?from=&to=`). The server
// aggregates game reported OUTSIDE a hunt over an inclusive date range, by
// species and by report type (downed/observed).

/** One species' downed/observed tally. `species` is the game pin's wire
    `games[].name` id (e.g. "moose"), localized client-side via the catalog. */
export interface GameReportSpeciesStatDto {
  species: string
  downed: number
  observed: number
  total: number
}

export interface TeamGameReportStatsDto {
  from: string
  to: string
  totalAnimals: number
  byType: { downed: number; observed: number }
  bySpecies: GameReportSpeciesStatDto[]
}

/** The authenticated fetcher returned by `useApiFetch`. */
export type ApiCall = <T>(path: string, init?: { method?: string; body?: string }) => Promise<T>

export function getTeamGameReportStats(
  call: ApiCall,
  groupId: string,
  from: string,
  to: string,
): Promise<TeamGameReportStatsDto> {
  // `from`/`to` are ISO-8601 instants; a `+HH:MM` offset carries a literal `+`
  // that a query string would otherwise read as a space, so both are encoded.
  const query = `from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
  return call<TeamGameReportStatsDto>(
    `/clubhouse/groups/${encodeURIComponent(groupId)}/game-report-stats?${query}`,
  )
}
